import React from 'react';
import { Box, Breadcrumbs, Container, Link, List, ListItem, ListItemText, Typography } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';
import { useNavigate } from 'react-router-dom';

export default function LinuxCstShippers() {
  const title = "Linux Install CST Instructions";
  const navigate = useNavigate();

  const handleBreadcrumbClick = () => {
    navigate('/shippers');
  }

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <ClassificationBannerHeader />
      <PageHeader title={ title } />

      <Box sx={{ mt: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="#c1d4e7" onClick={handleBreadcrumbClick} sx={{ '&:hover': { cursor: 'pointer' } }}>
                  Shippers
              </Link>
              <Typography color="white"> / </Typography>
              <Typography color="white">{ title }</Typography>
          </Breadcrumbs>
      </Box>
      
      <Box
        sx={{
          maxWidth: 1000,
          margin: 'auto',
          p: 3,
          mt: 5,
          border: '1px solid #ccc',
          borderRadius: 2,
          boxShadow: 2,
          backgroundColor: '#1A1A1A',
        }}
      >
        <Typography variant="h5" gutterBottom fontWeight="bold">
          RedHat/CentOS/OracleLinux Shippers Install Instructions
        </Typography>
        <List>
          <ListItem>
            <ListItemText
              primary="1. Extract the contents of the package containing the shippers. It should contain a folder labeled 'install' as well as a script labeled 'Run_This.sh'"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="2. Within the location that the package was extracted to, run 'sudo Run_This.sh'"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="3. Once finished, verify that the shippers are running with 'systemctl status filebeat' and 'systemctl status wazuh-agent'"
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="4. Any issues during install will be logged in install/ship_install.log and/or install/hids_install.log"
            />
          </ListItem>
        </List>
        <Typography variant="body1" mt={2}>
          The install should run smoothly with no errors and should start the shippers automatically. If you encounter any problems, please contact us at{' '}
          <Typography component="span" fontWeight="bold">support@cancgroup.com</Typography>.
        </Typography>
      </Box>
    </Container>
  );
}
